import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import { ROUTES } from './constants/routes';

// Lazy loading pages and components
const Home = lazy(() => import('./pages/Home'));
const Portfolio = lazy(() => import('./pages/Portfolio'));
const Services = lazy(() => import('./pages/Services'));
const Contact = lazy(() => import('./pages/Contact'));
const Redes = lazy(() => import('./pages/Redes'));
const Promo250705 = lazy(() => import('./components/Promociones/Promo250705'));
const StaticHtmlPage = lazy(() => import('./components/StaticHtmlPage'));

function App() {
  return (
    <>
      <Header />
      <main>
        <Suspense fallback={<div className="container" style={{ padding: '2rem', textAlign: 'center' }}>Cargando...</div>}>
          <Routes>
            <Route path={ROUTES.HOME} element={<Home />} />
            <Route path={ROUTES.PORTFOLIO} element={<Portfolio />} />
            <Route path={ROUTES.SERVICES} element={<Services />} />
            <Route path={ROUTES.CONTACT} element={<Contact />} />
            <Route path={ROUTES.NETWORKS} element={<Redes />} />
            <Route path={ROUTES.PROMO_250705} element={<Promo250705 />} />
            <Route
              path={ROUTES.PRIVACY}
              element={
                <StaticHtmlPage
                  title="Aviso de Privacidad"
                  htmlPath="/legal/aviso_privacidad.html"
                />
              }
            />
            <Route
              path={ROUTES.PAYMENT_TERMS}
              element={
                <StaticHtmlPage
                  title="Términos de Pago Electrónico"
                  htmlPath="/legal/terminos_de_pago.html"
                />
              }
            />
            <Route path="*" element={<div>Página no encontrada</div>} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </>
  );
}

export default App;
